export default "__VITE_ASSET__BoKHBQCH__"